/**
 * SystemFooter — barra inferior global del producto.
 *
 * Vive como tercer row del shell raíz, debajo de la fila
 * `Sidebar + (Topbar + main)`. Es `shrink-0`, así nunca scrollea ni se
 * mueve — flex la ancla al fondo del viewport.
 *
 * Contenido actual (mínimo):
 *   - Izquierda: brand mark + "Producto de I+Dea · Kernel"
 *   - Derecha: copyright dinámico con el año actual
 *
 * Espacio reservado para extender con: links a términos, privacidad,
 * status page, versión del build, etc. Cuando lleguen esos, los
 * agregamos como secciones internas — el contenedor ya está aquí.
 */

import { useTranslation } from 'react-i18next'

import { BrandMark } from './BrandMark'

export function SystemFooter() {
  const { t } = useTranslation('shell')
  const year = new Date().getFullYear()

  return (
    <footer
      role="contentinfo"
      className="shrink-0 border-t border-line bg-surface px-6 py-3 flex items-center justify-between gap-4 text-[11px] text-ink-muted"
    >
      {/* Brand + ownership */}
      <div className="flex items-center gap-2 min-w-0">
        <BrandMark className="h-3.5 w-3.5 text-brand shrink-0" />
        <span className="font-mono">
          <span className="font-semibold text-ink">{t('brand.name')}</span>
          <span className="text-brand mx-0.5">·</span>
          <span className="text-ink-muted">{t('brand.product')}</span>
        </span>
        <span className="text-ink-subtle hidden sm:inline">·</span>
        <span className="hidden sm:inline truncate">
          {t('footer.powered_by')}{' '}
          <span className="font-medium text-ink">{t('footer.owners')}</span>
        </span>
      </div>

      {/* Copyright */}
      <p className="shrink-0 text-ink-subtle">
        {t('footer.copyright', { year })} ·{' '}
        <span className="hidden md:inline">{t('footer.rights_reserved')}</span>
      </p>
    </footer>
  )
}
